module.exports = __webpack_public_path__ + "media/images/flags/16/Ecuador-baf4635188c0dea43a709aacb443bb9c.png";